import i18n from '@/lang/i18n'

export default function() {
    return [
        {
            type: 'customCheckbox'
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.externalCode'),
            colId: 'code',
            field: 'code',
            minWidth: 80
        },
        {
            type: 'text',
            headerName: i18n.tc('configuration.sections.priorities', 1),
            colId: 'nameTranslationKey',
            field: 'name',
            minWidth: 280,
            flex: 1
        },
        {
            type: 'checkIconRenderer',
            headerName: i18n.t('configuration.grid.active'),
            colId: 'active',
            field: 'active',
            flex: 2
        },
        {
            type: 'priorityColorRenderer',
            headerName: i18n.t('configuration.grid.color'),
            colId: 'color',
            field: 'color',
            filter: false,
            sortable: false,
            flex: 2
        },
        {
            type: 'number',
            headerName: i18n.t('configuration.grid.level'),
            colId: 'level',
            field: 'level',
            filter: false,
            sort: 'asc',
            minWidth: 80
        },
        {
            type: 'flagsRenderer',
            headerName: i18n.t('configuration.grid.translations'),
            colId: 'nameTranslations',
            field: 'nameTranslations',
            filter: false,
            sortable: false,
            flex: 2
        }
    ]
}
